/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the patient cycle-tracking feature (menstruation tracker). Off when absent, like all modules.
 * @export
 * @interface CycleTrackingModule
 */
export interface CycleTrackingModule {
    /**
     * 
     * @type {boolean}
     * @memberof CycleTrackingModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the CycleTrackingModule interface.
 */
export function instanceOfCycleTrackingModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CycleTrackingModuleFromJSON(json: any): CycleTrackingModule {
    return CycleTrackingModuleFromJSONTyped(json, false);
}

export function CycleTrackingModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CycleTrackingModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function CycleTrackingModuleToJSON(value?: CycleTrackingModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

